import { render, staticRenderFns } from "./Handwriting.vue?vue&type=template&id=e63a8388&"
import script from "./Handwriting.vue?vue&type=script&lang=js&"
export * from "./Handwriting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports